angular.module('logbook')
.directive('saveCancelForm', ['$timeout', function($timeout) {
   return {
      restrict: 'E',

      scope: {
         name: '@',
         onshow: '=?',
         onbeforesave: '=?',
         oncancel: '=?',
         isDisabled: '=?',
         form: '=?',
         showForm: '=?'
      },

	  template: require('./save-cancel-form.html'),

      link: function(scope, elem, attrs) {
         scope.form = scope[scope.name];
         if( scope.showForm )
            scope.form && scope.form.$show();
         //console.log(scope.form);
         
         scope.doOnshow = function() {
            if( scope.onshow )
               return scope.onshow();
         };
         
         scope.doOnbeforesave = function() {
            if( scope.onbeforesave) 
               return scope.onbeforesave();
         };
         
         scope.doCancel = function() {
            scope.form && scope.form.$cancel();
            scope.oncancel && scope.oncancel();
         }
      }
    };
  }]);
